const PENDING_TWO_FACTOR_SETUP_STORAGE_KEY = 'project314.pending-two-factor-setup';

interface PendingTwoFactorSetupRecord {
    email: string;
}

function readPendingTwoFactorSetupRecord(): PendingTwoFactorSetupRecord | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const rawValue = window.localStorage.getItem(PENDING_TWO_FACTOR_SETUP_STORAGE_KEY);

    if (!rawValue) {
        return null;
    }

    try {
        const parsedValue = JSON.parse(rawValue) as Partial<PendingTwoFactorSetupRecord>;

        if (typeof parsedValue.email !== 'string' || parsedValue.email.trim().length === 0) {
            window.localStorage.removeItem(PENDING_TWO_FACTOR_SETUP_STORAGE_KEY);
            return null;
        }

        return {
            email: parsedValue.email.trim().toLowerCase()
        };
    } catch {
        window.localStorage.removeItem(PENDING_TWO_FACTOR_SETUP_STORAGE_KEY);
        return null;
    }
}

export function setPendingTwoFactorSetupEmail(email: string): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.localStorage.setItem(
        PENDING_TWO_FACTOR_SETUP_STORAGE_KEY,
        JSON.stringify({
            email: email.trim().toLowerCase()
        } satisfies PendingTwoFactorSetupRecord)
    );
}

export function clearPendingTwoFactorSetupEmail(): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.localStorage.removeItem(PENDING_TWO_FACTOR_SETUP_STORAGE_KEY);
}

export function hasPendingTwoFactorSetup(
    email: string | null | undefined,
    isTwoFactorEnabled: boolean | number | null | undefined
): boolean {
    if (!email || Boolean(isTwoFactorEnabled)) {
        return false;
    }

    return readPendingTwoFactorSetupRecord()?.email === email.trim().toLowerCase();
}
